import { createSlice } from '@reduxjs/toolkit'
import { RootState } from '../store'

type DrawerSliceType = {
    drawerOpen: boolean
    shoppingCart: boolean
    selectCustomer: boolean
    openSelectSalesman: boolean
}

const initialState: DrawerSliceType = {
    drawerOpen: false,
    shoppingCart: false,
    selectCustomer: false,
    openSelectSalesman: false,
}

const drawerSlice = createSlice({
    name: 'drawer',
    initialState,
    reducers: {
        onOpenDrawer (state, { payload }: { payload: boolean}) {
            state.drawerOpen = payload
        },
        onSetShoppinCart (state, { payload }: { payload: boolean}) {
            state.shoppingCart = payload
        },
        onSetDraweSelectCustomer (state, { payload }: { payload: boolean}) {
            state.selectCustomer = payload
        },
        onSetDraweSelectSalesman (state, { payload }: { payload: boolean}) {
            state.openSelectSalesman = payload
        },
    }
})

export const selectDrawerState = (state: RootState) => state.drawerSlice;
export default drawerSlice.reducer

export const {
    onOpenDrawer,
    onSetShoppinCart,
    onSetDraweSelectCustomer,
    onSetDraweSelectSalesman,
} = drawerSlice.actions
